import InspiringDocs from './InspiringDocs'

export default InspiringDocs
// eslint-disable-next-line import/export
export * from './InspiringDocs'
